import script from "./DonateRequest.vue?vue&type=script&setup=true&lang=js"
export * from "./DonateRequest.vue?vue&type=script&setup=true&lang=js"

import "./DonateRequest.vue?vue&type=style&index=0&id=a98bdcb6&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a98bdcb6"]])

export default __exports__